import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PlansList from './PlansList';
import AddonsList from './AddonsList';

const PlansAndAddons = () => {
  const [activeTab, setActiveTab] = useState('plans');
  const navigate = useNavigate();
  const authState = useSelector((store) => store.auth);
  const subAdminData = useSelector((store) => store.subAdmin.detail);
  
  const resolvedAdminType = (subAdminData?.admin_type || authState?.admin_type || "")?.toLowerCase();

  useEffect(() => {
    if (resolvedAdminType !== "super admin") {
      navigate('/dashboard', { replace: true });
    }
  }, [resolvedAdminType, navigate]);

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/class-schedules-selected.png" alt="" /> Subscription Management
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <ul className="nav nav-pills group-nav mb-1 mt-2">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'plans' ? 'active' : ''}`}
                  type="button"
                  onClick={() => setActiveTab('plans')}
                >
                  Plans
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'addons' ? 'active' : ''}`}
                  type="button"
                  onClick={() => setActiveTab('addons')}
                >
                  Add-Ons
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-sm-12">
            <div className="tab-content" id="pills-tabContent">
              <div className="tab-pane fade show active">
                {activeTab === 'plans' && <PlansList />}
                {activeTab === 'addons' && <AddonsList />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default PlansAndAddons;
